module.exports = __webpack_public_path__ + "img/background_blue.8ddc7c9e.svg";